import { PublicClientApplication, EventType } from '@azure/msal-browser'
import azureConfig from 'configs/azure.config'

const msalConfig = {
    auth: {
        clientId: azureConfig.clientId,
        authority: `${azureConfig.authorityBase}/${azureConfig.tenantId}`,
        redirectUri: azureConfig.redirectUri,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
}

const msalInstance = new PublicClientApplication(msalConfig)

// Ensure redirect handling is registered
msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
        const account = event.payload.account
        msalInstance.setActiveAccount(account)
    }
})

export async function initializeMsal() {
    // Handle redirect responses if any
    await msalInstance.initialize()
    await msalInstance.handleRedirectPromise().catch(() => {})
    const active = msalInstance.getActiveAccount()
    if (!active) {
        const accounts = msalInstance.getAllAccounts()
        if (accounts.length > 0) {
            msalInstance.setActiveAccount(accounts[0])
        }
    }
    return msalInstance
}

export async function loginWithRedirect() {
    return msalInstance.loginPopup({
        scopes: azureConfig.scopes,
    })
}

export function getActiveAccount() {
    return msalInstance.getActiveAccount()
}

export async function acquireIdToken() {
    const account = msalInstance.getActiveAccount()
    if (!account) return null
    try {
        const result = await msalInstance.acquireTokenSilent({
            account,
            scopes: azureConfig.scopes,
        })
        return result.idToken
    } catch (e) {
        return null
    }
}

export async function signOut() {
    const account = msalInstance.getActiveAccount()
    return msalInstance.logoutRedirect({ account })
}

export default msalInstance
